// import { Icon } from "@mui/material";
// import React from "react";

// const IconComponent = ({
//   color,
//   fontSize,
//   iconLabel,
//   transform = false,
//   rounded=true,
//   ...props
// }) => {
//   const styles = {
//     iconComponent: {
//       fontSize: fontSize,
//       color: color,
//       transform: transform && "rotate(90deg)"
//     },
//   };
//   const classes = styles;

//   return (
//     <Icon baseClassName={rounded && "material-icons-round"} style={classes.iconComponent} {...props}>
//      { iconLabel}
//     </Icon>
//   );
// };

// export default IconComponent;

import { Icon } from "@mui/material";
import React from "react";

const IconComponent = ({
  color,
  fontSize,
  iconLabel,
  transform = false,
  rounded = true,
  iconVariant, // ✅ NEW
  ...props
}) => {
  const baseClassName = iconVariant
    ? iconVariant === "outlined"
      ? "material-icons-outlined"
      : iconVariant === "round"
      ? "material-icons-round"
      : iconVariant === "sharp"
      ? "material-icons-sharp"
      : "material-icons"
    : rounded
    ? "material-icons-round"
    : "material-icons";

  return (
    <Icon
      baseClassName={baseClassName}
      style={{
        fontSize: fontSize,
        color: color,
        transform: transform && "rotate(90deg)",
      }}
      {...props}
    >
      {iconLabel}
    </Icon>
  );
};

export default IconComponent;
